import { render, staticRenderFns } from "./OrganizeProductTypes.vue?vue&type=template&id=f948b304&scoped=true&"
import script from "./OrganizeProductTypes.vue?vue&type=script&lang=js&"
export * from "./OrganizeProductTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f948b304",
  null
  
)

export default component.exports